import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import { closed } from "../../components/drawer/drawerSlice";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  createMealType,
  getAllMealType,
  getMealTypeByID,
  updateMealType,
} from "./services/mealtype.services";
import { clearMealTypeDetails } from "./mealtypeSlice";

const CreateMealType: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const MealTypeDetail = useAppSelector(
    (state) => state.mealType.MealTypeDetail
  );
  const MealTypeID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.mealType.formLoading);

  useEffect(() => {
    if (MealTypeID) {
      dispatch(getMealTypeByID(MealTypeID));
    }
  }, [MealTypeID]);

  useEffect(() => {
    return () => {
      dispatch(clearMealTypeDetails());
      dispatch(closed());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      if (!MealTypeID) {
        const payload = {
          MealType: values.MealType,
          IsActive: true,
        };
        const response = await dispatch(createMealType(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearMealTypeDetails());
          dispatch(getAllMealType());
        }
      } else {
        const payload = {
          ID: MealTypeID,
          MealType: values.MealType,
          IsActive: values.IsActive,
        };
        const response = await dispatch(updateMealType(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearMealTypeDetails());
          dispatch(getAllMealType());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={MealTypeDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="MealType"
                label="Meal Type"
                component={FormTextField}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginRight: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
              <ButtonWithLoading
                label={MealTypeID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateMealType;
